import { IconType } from "../../../../design-system/feather-icon/feather-icon-map"

export type DisplayData = {
  iconType: IconType
}

export const CASE_STUDY_DISPLAY_DATA_MAP = {
  companyIndustry: {
    iconType: "briefcase",
  },
  companySize: {
    iconType: "users",
  },
  countriesSentTo: {
    iconType: "globe",
  },
  averagePayoutValue: {
    iconType: "dollar-sign",
  },
  productsUsed: {
    iconType: "credit-card",
  },
} as const satisfies Record<string, DisplayData>

export type CaseStudyInfoKey = keyof typeof CASE_STUDY_DISPLAY_DATA_MAP
